export default "__VITE_ASSET__CPyakdIv__"